<template>
  <div class="top-nav">
    <van-tabs
      v-model="activeIndex"
      :background="config.property_data.background_color"
      :color="config.property_data.selected_font_color"
      :title-active-color="config.property_data.selected_font_color"
      :title-inactive-color="config.property_data.unselected_font_color"
      :inactive-color="config.property_data.unselected_font_color"
      @click="handleSelect"
    >
      <van-tab
        :title="item.name"
        :name="index"
        v-for="(item, index) in config.link_data"
        :key="index"
        :index="index.toString()"
      >
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-top-nav",
  props: ["config", "isEditorStatus", "pageData"],

  data() {
    return {
      property_data: {},
      activeIndex: 0,
      distances: [],
      isScroll: false,
    };
  },

  computed: {},

  components: {},

  mounted() {
    let htop = $(".top-nav").offset().top + 116;
    window.onscroll = () => {
      //获取页面滚动条的滚动距离
      let scrollTop = this.scrollPage().scrollTop;
      if (scrollTop >= htop) {
        $(".top-nav").addClass("fixed");
        $("body").css({ "padding-top": "45px" });
      }

      // 页面第一次滚动时候，获取各个锚点高度
      if (this.pageData && !this.isScroll) {
        const len = this.pageData.module_list.filter(
          (item) => item.module_code === "anchor"
        ).length;
        if (len) {
          this.calcAnchor(len);
        }
        this.isScroll = true;
      }
      // tab 和 锚点的联动
      let len = this.distances.length;
      this.distances.reduce((pre, cur, index) => {
        // 判断是否在某段区间内， 100是给的缓冲距离
        let prePos = pre - 100;
        let curPos = cur - 100;
        if (scrollTop > prePos && scrollTop < curPos) {
          this.activeIndex = index - 1 > 0 ? index - 1 : 0;
          // 必须是确定是数组中最后一个区间
        } else if (scrollTop > curPos && index + 1 === len) {
          this.activeIndex = index;
        }
        return cur;
      }, 0);
    };
  },

  methods: {
    scrollPage() {
      return {
        scrollTop:
          window.pageYOffset ||
          document.body.scrollTop ||
          document.documentElement.scrollTop ||
          0,
      };
    },
    handleSelect(index) {
      this.jump(this.config.link_data[index].link_data);
    },
    jump(item) {
      if (!item) {
        return;
      }
      if (item.toString().startsWith("#")) {
        this.goToAnchor(item);
        return;
      } else {
        redirectURL(item.toString(), "seller");
      }
    },
    goToAnchor(name) {
      const returnEle = document.querySelector(name); // 将要跳转区域的锚点
      if (returnEle) {
        $("html, body").animate(
          { scrollTop: $(returnEle).offset().top - 40 },
          400
        );
        return false;
      }
    },
    calcAnchor(count) {
      this.$nextTick(() => {
        for (let i = 0; i < count; i++) {
          let offsetTop =
            document.getElementsByClassName("tms-anchor")[i].offsetParent
              .offsetTop;
          this.distances.push(offsetTop);
        }
      });
    },
  },
};
</script>


<style  lang="scss" scoped>
@import "./index.scss";
</style>